import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

function Consultation() {
  return (
    <div className="min-h-screen bg-white text-[#0a0a0a]">
      <Navbar />
      <main className="pt-32 pb-20">
        <div className="container">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">IDTA Consultation Service</h1>
            <p className="text-lg text-[#64748b] mb-12">
              Expert guidance for AAS implementation and digital transformation.
            </p>
            
            <div className="space-y-8">
              <section>
                <h2 className="text-2xl font-bold mb-4">Our Services</h2>
                <p className="text-[#64748b] mb-6">
                  We provide comprehensive consultation services to help organizations implement 
                  Asset Administration Shell (AAS) standards and digital twin technologies.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4">Contact Us</h2>
                <p className="text-[#64748b] mb-4">
                  For consultation inquiries, please contact us at:
                </p>
                <p className="text-[#64748b]">
                  Email: <a href="mailto:info@idtwin.org" className="text-[#0028CD] hover:underline">info@idtwin.org</a><br />
                  Phone: +49 69 6603 1939
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default Consultation;
